export function buildCustomerStatusById(pipelineReport) {
  const statusByCustomerId = {};
  (pipelineReport?.stages || []).forEach((stage) => {
    (stage.customers || []).forEach((customer) => {
      statusByCustomerId[customer.customerId] = stage.status;
    });
  });
  return statusByCustomerId;
}

export function formatPipelineStageLabel(status) {
  return status || 'Unspecified';
}

export function formatPipelineStageHeader(status) {
  return formatPipelineStageLabel(status).toUpperCase();
}

export const PIPELINE_STAGE_ORDER = [
  'Live',
  'Confirmatory & Closing',
  'LOI/Term Sheet',
  'Underwriting',
  'Data collection',
  'Send data request',
  'Discovery',
  'On Hold/Nurture',
  'Lost',
  'Unspecified',
  'Passed',
];

export function sortPipelineStages(stages = []) {
  const orderIndex = new Map(
    PIPELINE_STAGE_ORDER.map((status, index) => [status, index])
  );

  return [...stages].sort((left, right) => {
    const leftIndex = orderIndex.has(left.status)
      ? orderIndex.get(left.status)
      : PIPELINE_STAGE_ORDER.length;
    const rightIndex = orderIndex.has(right.status)
      ? orderIndex.get(right.status)
      : PIPELINE_STAGE_ORDER.length;
    if (leftIndex !== rightIndex) {
      return leftIndex - rightIndex;
    }
    return formatPipelineStageLabel(left.status).localeCompare(
      formatPipelineStageLabel(right.status)
    );
  });
}

const DEFAULT_STAGE_THEME = {
  dot: '#9CA3AF',
  headerBg: '#F3F4F6',
  headerText: '#374151',
  columnBg: '#F9FAFB',
  countBg: '#E5E7EB',
  countText: '#374151',
};

const PIPELINE_STAGE_THEMES = {
  Discovery: {
    dot: '#7C3AED',
    headerBg: '#EDE9FE',
    headerText: '#5B21B6',
    columnBg: '#F5F3FF',
    countBg: '#DDD6FE',
    countText: '#5B21B6',
  },
  'Send data request': {
    dot: '#2563EB',
    headerBg: '#DBEAFE',
    headerText: '#1D4ED8',
    columnBg: '#EFF6FF',
    countBg: '#BFDBFE',
    countText: '#1D4ED8',
  },
  'Data collection': {
    dot: '#D97706',
    headerBg: '#FEF3C7',
    headerText: '#B45309',
    columnBg: '#FFFBEB',
    countBg: '#FDE68A',
    countText: '#B45309',
  },
  Underwriting: {
    dot: '#DB2777',
    headerBg: '#FCE7F3',
    headerText: '#BE185D',
    columnBg: '#FDF2F8',
    countBg: '#FBCFE8',
    countText: '#BE185D',
  },
  'LOI/Term Sheet': {
    dot: '#EA580C',
    headerBg: '#FFEDD5',
    headerText: '#C2410C',
    columnBg: '#FFF7ED',
    countBg: '#FED7AA',
    countText: '#C2410C',
  },
  Passed: {
    dot: '#0D9488',
    headerBg: '#CCFBF1',
    headerText: '#0F766E',
    columnBg: '#F0FDFA',
    countBg: '#99F6E4',
    countText: '#0F766E',
  },
  'Confirmatory & Closing': {
    dot: '#1D4ED8',
    headerBg: '#DBEAFE',
    headerText: '#1E3A8A',
    columnBg: '#EFF6FF',
    countBg: '#93C5FD',
    countText: '#1E3A8A',
  },
  'On Hold/Nurture': {
    dot: '#64748B',
    headerBg: '#E2E8F0',
    headerText: '#334155',
    columnBg: '#F8FAFC',
    countBg: '#CBD5E1',
    countText: '#334155',
  },
  Live: {
    dot: '#059669',
    headerBg: '#D1FAE5',
    headerText: '#047857',
    columnBg: '#ECFDF5',
    countBg: '#A7F3D0',
    countText: '#047857',
  },
  Lost: {
    dot: '#DC2626',
    headerBg: '#FEE2E2',
    headerText: '#B91C1C',
    columnBg: '#FEF2F2',
    countBg: '#FECACA',
    countText: '#B91C1C',
  },
  Unspecified: DEFAULT_STAGE_THEME,
};

export function getPipelineStageTheme(status) {
  return PIPELINE_STAGE_THEMES[formatPipelineStageLabel(status)] || DEFAULT_STAGE_THEME;
}
